import React, { useMemo } from "react";

import { useVersionReviews } from "utils";

import { VersionReviewsTable } from "pages/admin/soilSight/components/shared/VersionReviewsTable.tsx";

type SoilSightSingleVersionReviewsProps = {
  onOpenVersion: (version: string) => void;
};

export const SoilSightSingleVersionReviews = ({ onOpenVersion }: SoilSightSingleVersionReviewsProps) => {
  const { data: reviews, isLoading: isLoadingReviews } = useVersionReviews();

  // Single-version reviews only — comparison reviews (baseline !== candidate) live on the multiple-version page's Reviews tab instead.
  const singleVersionReviews = useMemo(() => reviews?.filter((r) => r.baselineVersion === r.candidateVersion), [reviews]);

  return (
    <VersionReviewsTable
      reviews={singleVersionReviews}
      isLoading={isLoadingReviews}
      description="Single-version reviews left by admins, grouped by version"
      groupLabel={(review) => review.baselineVersion}
      detailLabel={(review) => review.baselineVersion}
      openTooltip="Open this version"
      onOpen={(record) => onOpenVersion(record.baselineVersion)}
    />
  );
};
